export const PoliticaDePrivacidad = () => {
    return (
        <section className="page-sectionWhite text-white mb-0 text-center">
            {/*<!-- Imagen nosotros-->*/}
            <div className="container px-2">
                <div className="row row-nosotros">
                    {/*<!-- nosotros Descripcion -->*/}
                    <div className="legales">
                        <div>
                            <h4 className="px-2 text-danger text-uppercase text-center">
                                <strong>Política de privacidad</strong>
                            </h4>
                            <p className="text-black">
                                La presente Política de Privacidad será
                                aplicable a los usuarios web titularidad de la
                                empresa <strong>TRT PRODUCCIONES</strong> S.L. (en adelante, “TRT
                                PRODUCCIONES”) en relación con el tratamiento de
                                datos personales recabados a través de las vías
                                habilitadas o mediante la relación contractual
                                mantenida.
                                <br></br>
                            </p>
                            <h6 className="text-black">
                                RESPONSABLE DEL TRATAMIENTO Y DATOS DE CONTACTO{" "}
                            </h6>
                            <p className="text-black">
                                A los efectos de la presente Política de
                                Privacidad, tendrá la condición de Responsable
                                del Tratamiento la sociedad con quien el usuario
                                mantiene una relación contractual y quien recaba
                                los datos personales del mismo.
                            </p>
                            <p className="text-black">
                                A los efectos de la presente Política de
                                Privacidad, tendrá la condición de Responsable
                                del Tratamiento la sociedad con quien el usuario
                                mantiene una relación contractual y quien recaba
                                los datos personales del mismo. La relación
                                contractual con los usuarios podrá ser
                                formalizada por <strong>TRT PRODUCCIONES</strong> por medio de
                                sus sociedades, que actuarán como responsables
                                del tratamiento respecto de los datos recabas en
                                los eventos organizados por cada una de ellas.
                                Tales sociedades son detalladas a continuación:
                            </p>
                            <ul className="text-black list">
                                <li>
                                    <strong><strong>TRT PRODUCCIONES</strong> </strong>
                                    con domicilio en C/ Río bergantes 9, CP
                                    29620 Torremolinos, Málaga
                                    <ul>
                                        <li>
                                            <strong>N.I.F:</strong> B16946550
                                        </li>
                                        <li>
                                            Correo de contacto:
                                            info@trtproducciones.com
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <h6 className="text-black">
                                DATOS OBJETO DE TRATAMIENTO
                            </h6>
                            <p className="text-black">
                                <strong>TRT PRODUCCIONES</strong> recogerá y tratará los datos
                                identificativos y de contacto facilitados por
                                los usuarios a través de los formularios de
                                contacto, así como los datos de facturación
                                derivados de la adquisición de las entradas.
                                Asimismo, <strong>TRT PRODUCCIONES</strong> tratará las imágenes
                                de los asistentes que puedan ser captadas
                                durante la celebración de los eventos conforma a
                                las finalidades indicadas en la presente
                                Política de Privacidad. <br /> Además, por el
                                hecho de navegar en esta página web y mediante
                                el uso de cookies, <strong>TRT PRODUCCIONES</strong> recaba datos
                                de los usuarios (como el tipo de navegador
                                utilizado, el sistema operativo o la dirección
                                IP), con el objeto de mejorar su navegación y
                                gestionar de manera efectiva el portal. Si desea
                                obtener más información respecto al uso de las
                                cookies, consulte nuestra Política de Cookies.
                            </p>
                            <h6 className="text-black">
                                FINALIDADES Y LEGITIMACIÓN DEL TRATAMIENTO
                            </h6>
                            <p className="text-black">
                                <strong>TRT PRODUCCIONES</strong> tratará sus datos personales
                                para las finalidades indicadas a continuación:
                            </p>
                            <ul className="text-black list">
                                <li>
                                    Obtener información estadística relativa al
                                    tráfico de la página web, basando el
                                    tratamiento en el interés legítimo de la
                                    compañía y/o en el consentimiento del
                                    interesado otorgado a través de la
                                    configuración de cookies.
                                </li>
                                <li>
                                    Gestionar su solicitud de información o
                                    contacto a través del formulario habilitado
                                    a tal efecto o mediante el correo
                                    electrónico indicado en nuestra página web,
                                    en base al consentimiento otorgado mediante
                                    la remisión de su consulta.
                                </li>
                                <li>
                                    Mantenerle informado sobre nuestras
                                    novedades y eventos basado en el
                                    consentimiento mostrado con la marcación de
                                    las casillas habilitadas o la suscripción a
                                    la Newsletter.
                                </li>
                                <li>
                                    Tramitar la adquisición de entradas y
                                    gestionar la asistencia al evento deseado,
                                    legitimado en la correcta ejecución del
                                    contrato y relación con el usuario.
                                </li>
                                <li>
                                    Captar imágenes o vídeos durante la
                                    celebración de los eventos, legitimado en el
                                    consentimiento otorgado al asistir al
                                    evento.
                                </li>
                                <li>
                                    Difundir y promocionar la actividad y
                                    eventos organizados por <strong>TRT PRODUCCIONES</strong> a
                                    través de la página web y redes sociales de
                                    <strong>TRT PRODUCCIONES</strong> y otros medios de
                                    comunicación autorizados, legitimado en su
                                    interés legítimo.
                                </li>
                            </ul>
                            <p className="text-black">
                                El hecho de no facilitar los datos solicitados e
                                identificados como campos obligatorios (*),
                                implicaría la imposibilidad por nuestra parte de
                                alcanzar las finalidades anteriormente
                                descritas.
                            </p>
                            <h6 className="text-black">
                                CONSERVACIÓN DE LOS DATOS
                            </h6>
                            <p className="text-black">
                                Los datos personales proporcionados por los
                                usuarios a través de nuestra página web serán
                                conservados durante el tiempo necesario para
                                cumplir de manera efectiva con las finalidades
                                arriba indicadas y con las obligaciones legales
                                derivadas. <br />
                                En particular, <strong>TRT PRODUCCIONES</strong> conservará los
                                datos de los usuarios mientras resulten
                                necesarios para atender las consultas planteadas
                                y ejecutar la relación contractual entre las
                                partes. La retirada de consentimiento por parte
                                de los usuarios no afectará a la licitud de los
                                tratamientos realizados previamente por TRT
                                PRODUCCIONES. <br />
                                En cuanto a la conservación de la información
                                relativa a los datos de navegación y cookies,
                                puede obtener más información en nuestra
                                Política de Cookies
                            </p>
                            <h6 className="text-black">
                                DESTINATARIOS DE LOS DATOS
                            </h6>
                            <p className="text-black">
                                Los datos personales podrán ser comunicados en
                                la medida en que dicha comunicación resulte
                                necesaria u obligatoria, de acuerdo con la
                                legislación vigente o para la correcta ejecución
                                de la relación con el usuario. <br />
                                Asimismo, y en caso de que el usuario hubiera
                                aceptado la recepción de comunicaciones
                                comerciales, los datos podrán ser comunicados a
                                las entidades identificadas en base al
                                consentimiento otorgado mediante la aceptación
                                de las casillas habilitadas. <br />
                                No están previstas transferencias
                                internacionales de datos personales, sin
                                perjuicio de que la información recabada por
                                cookies de terceros sea objeto de este tipo de
                                operaciones. Puede obtener más información
                                acerca de estas transferencias en nuestra
                                Política de Cookies.
                            </p>
                            <h6 className="text-black">
                                DERECHOS DE LOS USUARIOS Y CLIENTES
                            </h6>
                            <p className="text-black">
                                En cualquier momento, los usuarios y clientes de
                                <strong>TRT PRODUCCIONES</strong> podrán ejercer los siguientes
                                derechos reconocidos por la normativa vigente de
                                protección de datos
                            </p>
                            <ul className="text-black list">
                                <li>
                                    <strong>Derecho de Acceso:</strong> permite
                                    al usuario conocer qué información se tiene,
                                    de dónde se ha obtenido, a quién se ha
                                    facilitado y con qué usos se ha tratado.
                                </li>
                                <li>
                                    <strong>Derecho de Rectificación:</strong>{" "}
                                    permite al usuario rectificar algún dato
                                    erróneo o desactualizado.
                                </li>
                                <li>
                                    <strong>Derecho de Supresión:</strong>{" "}
                                    permite al usuario solicitar que se dejen de
                                    tratar sus datos.
                                </li>
                                <li>
                                    <strong>Derecho de Limitación:</strong>{" "}
                                    permite al usuario restringir el tratamiento
                                    de sus datos, pero de forma que sean
                                    conservados para alguna finalidad posterior
                                    (una reclamación judicial, por ejemplo).
                                </li>
                                <li>
                                    <strong>Derecho de Portabilidad:</strong>{" "}
                                    permite al usuario obtener una copia de sus
                                    datos en forma electrónica y, en
                                    determinadas circunstancias, solicitar que
                                    sean comunicados a otro prestador de
                                    servicios.
                                </li>
                                <li>
                                    <strong>Derecho de Oposición:</strong>{" "}
                                    permite al usuario oponerse al interés
                                    legítimo de <strong>TRT PRODUCCIONES</strong> para solicitar
                                    el cese del tratamiento de sus datos.
                                </li>
                                <li>
                                    <strong>
                                        Derecho a Retirar el Consentimiento:
                                    </strong>{" "}
                                    en cualquier momento, respecto de
                                    tratamiento de sus datos personales, sin que
                                    ello afecte a la licitud del mismo.
                                </li>
                            </ul>
                            <p className="text-black">
                                Los usuarios pueden ejercer estos derechos
                                mediante a través de la dirección de correo
                                electrónico info@trtproducciones.com, indicando
                                qué derecho desea ejercitar y aportando su DNI o
                                documento acreditativo de su identidad similar.
                                Adicionalmente, presentar una reclamación ante
                                la Agencia Española de Protección de Datos, a
                                través de su página web.
                            </p>
                            <h6 className="text-black">
                                MODIFICACIÓN DE LA POLÍTICA DE PRIVACIDAD
                            </h6>
                            <p className="text-black">
                                <strong>TRT PRODUCCIONES</strong> se reserva el derecho a
                                modificar la presente Política de Privacidad,
                                siempre de acuerdo con los términos permitidos
                                por la legislación española vigente y con la
                                correspondiente comunicación a los usuarios,
                                mediante la publicación en esta página web o por
                                cualquier otro medio de comunicación o difusión
                                que se considere oportuno. <br />
                                <br />
                                <strong>
                                    Fecha de actualización: ENERO 2022.
                                </strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PoliticaDePrivacidad
